<div
  class="cap-alerts-page"
  rvSpinner="cap-alerts-page-loading"
  [rvShowSpinner]="pageService.busy()"
  [attr.aria-busy]="pageService.busy() ? 'true' : null"
>
  @if (pageService.error(); as error) {
    <div class="cap-alerts-page__banner tw-px-8 tw-pt-4">
      <notification-alert
        id="errorBox"
        type="danger"
        [title]="error.title"
        [message]="error.detail"
        [showCloseButton]="error.kind !== 'catalog'"
        (dismissed)="pageService.dismissError()"
      >
        @if (error.kind === 'catalog') {
          <button
            #retryButton
            rv-button
            variant="secondary"
            size="small"
            type="button"
            id="retryButton"
            (click)="retry()"
          >
            Retry
          </button>
        }
      </notification-alert>
    </div>
  }

  @switch (pageService.view()) {
    @case ('disclaimer') {
      <div class="cap-alerts-page__stage tw-p-8">
        <cap-alerts-disclaimer
          [disabled]="pageService.readOnly()"
          [busy]="pageService.loading()"
          (accepted)="pageService.accept()"
          (cancelled)="cancelDisclaimer()"
        />
      </div>
    }
    @case ('picker') {
      <div class="cap-alerts-page__stage tw-p-8">
        <cap-alert-template-picker
          [templates]="pageService.templates()"
          [currentCode]="pageService.formValue().templateProductCode"
          [currentPresentation]="pageService.formValue().presentationId"
          [mode]="pageService.pickerMode()"
          [showCustomPresentation]="pageService.showCustomPresentation()"
          [canChoosePresentation]="pageService.canChoosePresentation()"
          (chosen)="pageService.choose($event)"
          (back)="pageService.closePicker()"
        />
      </div>
    }
    @default {
      <div class="cap-alerts-page__body">
        <div class="cap-alerts-page__preview tw-p-8">
          @if (pageService.view() === 'page') {
            <div class="cap-alerts-page__heading">
              <h2 class="cap-alerts-page__title">
                {{ pageService.templateName() }}
              </h2>
              <button
                #changeTemplateButton
                rv-button
                variant="secondary"
                id="changeTemplateButton"
                type="button"
                [disabled]="pageService.readOnly()"
                (click)="pageService.openPicker()"
              >
                <mat-icon svgIcon="switch" aria-hidden="true" />
                Change template
              </button>
            </div>
            <cap-alert-preview
              class="tw-mt-4"
              [productCode]="pageService.formValue().templateProductCode"
              [presentationName]="pageService.previewPresentationName()"
              [attributeData]="pageService.previewAttributeData()"
              [displayData]="pageService.displayData()"
              [label]="pageService.previewLabel()"
              [aspectRatio]="pageService.previewAspectRatio()"
              [contentWidth]="pageService.previewContentWidth()"
            />
          }
        </div>

        <div class="cap-alerts-page__panel tw-p-6">
          @if (pageService.view() === 'page') {
            <mat-tab-group
              class="cap-alerts-page__tabs borderless"
              [selectedIndex]="selectedIndex()"
              (selectedIndexChange)="selectTab($event)"
              mat-stretch-tabs="true"
              animationDuration="0ms"
            >
              <mat-tab label="Connect">
                <div class="tw-pt-6">
                  <cap-alerts-connect-tab />
                </div>
              </mat-tab>
              <mat-tab label="Settings">
                <div class="tw-pt-6">
                  <cap-alerts-settings-tab />
                </div>
              </mat-tab>
            </mat-tab-group>
          }
        </div>
      </div>

      @if (pageService.view() === 'page') {
        <div class="cap-alerts-page__footer">
          <div *requireAccess="exportAccess" class="cap-alerts-page__export">
            <button
              rv-button
              variant="secondary"
              id="exportButton"
              type="button"
              (click)="pageService.exportAlerts()"
            >
              Export alert history
            </button>
          </div>
          <common-actions
            class="cap-alerts-page__actions"
            [actions]="actions()"
            [saving]="pageService.saving()"
            [changeDate]="pageService.changeDate()"
            [changedBy]="pageService.changedBy()"
          />
        </div>
      }
    }
  }
</div>
